import Header from "./Header";
import BottomNav from "./BottomNav";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-shell">
      <Header />
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 py-6 pb-24">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
